<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="23.645" height="17.277" viewBox="0 0 23.645 17.277">
		<g transform="translate(0.693 0.5)">
			<path
				d="M1219.119,748.2a1.649,1.649,0,1,1-1.649-1.649A1.649,1.649,0,0,1,1219.119,748.2Z"
				transform="translate(-1199.796 -744.344)"
				fill="none"
				stroke="#c1c5cb"
				stroke-width="1"
			/>
			<rect
				width="22.421"
				height="16.277"
				rx="1.666"
				stroke-width="1"
				stroke="#c1c5cb"
				stroke-linecap="round"
				stroke-linejoin="round"
				fill="none"
			/>
			<path
				d="M1189.24,762.616l6.613-9.936,5.476,6.7,3.551-3.79,6.606,7.022"
				transform="translate(-1189.24 -746.777)"
				fill="none"
				stroke="#c1c5cb"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="1"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ImageSvg',
};
</script>

<style scoped lang="scss"></style>
